const REGEX_PHONE = /^(\d{3})(\d{3})(\d{4})$/;
export function formatPhoneNumber(number) {
    const match = REGEX_PHONE.exec(number);
    if (!match) {
        return number;
    }
    const [, area, prefix, line] = match;
    return `+1 (${area}) ${prefix}-${line}`;
}
